import { environment } from "../../../../environments/environment"

export const CONSTANTS = {

    API: {
        BASE_URL: environment.baseUrl,
        CONT_BASE_URL: environment.contBaseUrl,
        FEED_BASE_URL: environment.feedBaseUrl,
        FEED_SOCK_URL: environment.feedSockBaseUrl,
        ORDER_BASE_URL: environment.orderBaseUrl,
        REPORT_BASE_URL: environment.reportBaseUrl,
        CDATA: "cdata/client",
        LOGOUT: "auth/logout/",
        LOGIN: "auth/login/",
        APP: {
            APP_STATE: "app/state",
            INIT_APP: "app/initialize"
        },
        BROKER: {
            USER_BROKERS: "baccount/list/",
            ADD_BROKER: "baccount/add/",
            UPDATE_BROKER: "baccount/update/",
            DELETE_BROKER: "baccount/delete/",
            CONNECT_BROKER: "baccount/connect/",
            FEED_ACCOUNT_LOGIN: "baccount/login/",
            ALL_BROKERS: "baccount/all/",
        },
        CHANNEL: {
            LIST: "feed/",
            MODE: "feed/mode/",
            SERVER_LIST: "channel/serverlist/",
            SWITCH: "feed/switch/",
            START_STOP: "feed/connect/",
            CONN_DETAILS: "channel/details/"
        },
        CLIENT: {
            // GET_STRATEGIES: "client/strategies",
            // CLOSE_LEG: "client/strategy/closeleg",
            // GET_REPORTS: "client/report",
            GET_STRATEGIES: "test/",
            CLOSE_LEG: "test/",
            GET_REPORTS: "test/",
        },
        CONFIG_DATA: {
            GET_CDS: "cdata/datas/",
            GET_AUTH_CDS: "cdata/authdatas/",
            UPDATE_CDS: "cdata/updatedatas/",
        },
        DATA_COLLECTION: {
            LIST_CATEGORIES: "dc/categories/",
            SPLIT_CATEGORY: "dc/category/split/",
            CHECK_DATA_STATUS: "dc/check/status/",
            RUN_DATA: "dc/run/",
            STOP_DATA: "dc/stop/",
            CHECK_DATA_RUN_STATUS: "dc/run/status/",
            ARCHIEVE_DATA: "dc/archive/run/",
            STOP_ARCHIEVE_DATA: "dc/archive/stop/",
            ARCHIEVE_DATA_RUN_STATUS: "dc/archive/run/status/"
        },
        INSTRUMENT: {
            GET_INSTRUMENT: "instrument/",
            GET_INSTRUMENTS: "instrument/list/",
            ADD_INSTRUMENT: "instrument/add/",
            UPDATE_INSTRUMENT: "instrument/update/",
            DELETE_INSTRUMENT: "instrument/delete/",
            GET_INSTRUMENTS_EXPIRY: "instrument/exp/",
            ADD_INSTRUMENT_EXPIRY: "instrument/update/exp/",
            DELETE_INSTRUMENT_EXPIRY: "instrument/delete/exp/",
        },
        TRADEBOARD: {
            ADD: "tradeboard/",
            UPDATE: "tradeboard/",
            DELETE: "tradeboard/",
            GET: "tradeboard/",
            GET_DETAILS: "tradeboard/",
        },
        USERS: {
            GET_USERS: "account/list/",
            ADD_USER: "account/add/",
            SIGNUP_USER: "account/signup/",
            GET_ACCOUNT: "account/",
            UPDATE_USER: "account/update/",
            DELETE_USER: "account/delete/",
            ACTIVATE_USER:"account/activate/",
            CHANGE_PASSWORD: "account/changepassword/",
            RESET_PASSWORD: "account/resetpassword/",
            GET_PROFILE:"account/profile/",
        },
        SYMBOLS: {
            GET_CATEGORIES: "categories/",
            GET_SEGMENTS: "segments/",
            GET_SYMBOLS: "symbols/",
        },
        STRATEGY: {
            GET_STRATEGIES: "strategy/list/",
            ADD_STRATEGY: "strategy/add/",
            UPDATE_STRATEGY: "strategy/update/",
            UPDATE_STRATEGY_STATE: "strategy/update/state/",
            UPDATE_STRATEGY_SCOPE: "strategy/update/scope/",
            DELETE_STRATEGY: "strategy/delete/"
        },
        REPORT: {
            GET_REPORTS: "report/",
            ADD_REPORT: "report/",
            UPDATE_REPORT: "report/",
            DELETE_REPORT: "report/",
            UPDATE_STATUS: "report/status/",
            GET_REPORT_DATA: "report/data/",
            UPDATE_REPORT_DATA: "report/data/",
            GENERATE_REPORT: "report/create/",
            DOWNLOAD_REPORT: "report/dl/",
        },
        THREAD: {
            GET_THREADS: "thread/list/",
            ADD_THREAD: "thread/add/",
            STOP_THREAD: "thread/stop/",
            START_THREAD: "thread/start/",
            UPDATE_THREAD: "thread/settings/update/",
            DELETE_THREAD: "thread/delete/",
            THREAD_ACTION: "thread/action/",
            THREAD_UPDATE_DNAME: "thread/dname/",
        },
        SCHEDULER: {
            GET_SCHEDULER: "thread/listaccs/",
            FILTER_SCHEDULER: "thread/filteraccs/",
            START_SCHEDULER: "thread/runaccs/",
            SEARCH_SCHEDULER: "thread/searchacc/",
        },
        LOG: {
            GET_LOGS: "tl/list/"
        },
        ORDER: {
            GET_ORDERS: "order",
            CANCEL_ORDER: "order",
        },
        PROFILE: {
            GET: "uprofileupdate/list/",
            POST: "uprofileupdate/update/"
        },
        POSITION: {
            GET_POSITIONS: "position",
        }
    },
    SOCKET_IDENTIFIER_KEYS: {
        HEADER: 'header'
    },
    COOKIE : {
        USERNAME: "un",
        EMAIL:"em",
        PHONE:"ph",
        IS_ADMIN:"adm",
        USER_ID: "us_id",
        HEADER_TOKEN: "header_token",
    },
    DATE_FORMAT: {
        DDMMYYYY: "ddmmyyyy",
        YYYYMMDD: "yyymmdd"
    },
    SUCCESS: "success",
    ERROR: "error",

    URI_PATH: {
        //Main Path
        TAH: 'tah',
        CLIENT: 'client',
        //Sub Path
        BROKERS: 'brokers',
        CHANNEL: 'channel',
        DASHBOARD: 'dashboard',
        DATA_COLLECTION: 'data-collection',
        LOGS: 'logs',
        MONTHLY_REPORT: 'monthly-report',
        ORDER_POS: 'order-positions',
        REPORT: 'report',
        REPORT_ALERTS: 'report-alerts',
        ENTITY: 'entity',
        ENTITY_STRATEGY: 'entity-strategy',
        ENTITY_INSTRUMENTS: 'entity-instruments',
        INSTRUMENTS_EXPIRY: 'instruments-expiry',
        SETTINGS: 'settings',
        THREAD: 'thread',
        TRADEBOARD: 'tradeboard',
        TBLIST: 'tblist',
        TUTORIAL: 'tutorial',
        USERS: 'users'
    },

    DEFAULT: {
        BROKER: { _id: 'select', name: 'Broker' },
        CATEGORY: { _id: 'select', name: 'Category' },
        SEGMENT: { _id: 'select', name: 'Segment' },
        INTERVAL: { _id: 0, name: 'Interval' },
        STRATEGY: { _id: 'select', display_name: 'Strategy', name: 'Strategy', disabled: true },
        SYMBOL: { _id: 'select', name: 'Symbol', trading_symbol: 'Symbol', disabled: true },
        USER: { full_name: "Select", _id: 0 },
    },

    INTERVALS : [
        { name: "1m", _id: 1 }, 
        { name: "2m", _id: 2 }, 
        { name: "3m", _id: 3 }, 
        { name: "4m", _id: 4 },
        { name: "5m", _id: 5 },
        { name: "10m", _id: 10 },
        { name: "15m", _id: 15 },
        { name: "30m", _id: 30 },
        { name: "1h", _id: 60 }
    ],

    DAYS: [ "MON", "TUE", "WED", "THUR", "FRI", "SAT" ],

    STRATEGY_STATES: {
        RUNNING: 'running',
        STOPPED: 'stopped'
    },

    ORB_REENTRY_ON_TYPES: [
        { name: "Both", _id: "both" },
        { name: "SL", _id: "sl" },
        { name: "Target", _id: "tgt" },
    ],

    ORB_REENTRY_WHAT_TYPES: [
        { name: "Other Leg", _id: "other_leg" },
        { name: "Same Leg", _id: "same_leg" },
        { name: "Both Legs", _id: "both_legs" },
    ],

    ORB_REENTRY_FREQ_TYPES: [
        { name: "Per Leg", _id: "per_leg" },
        { name: "Both Legs", _id: "both_legs" },
    ],

    ORB_RUNMODE_TELEGRAM_TYPES: [
        { name: "Channel", _id: "channel" },
        { name: "User", _id: "user" },
    ],

    ORB_SS_SEGMENTS: [
        { name: "Spot", _id: "spot" },
        { name: "Options", _id: "options" },
    ],

    ORB_SS_SPOT_TYPES: [
        { name: "ATM", _id: "default", max_enabled: false, min_holder: '+/- Value', max_holder: 'NA', inc: 'strike', min_length_holder: 'NA', max_length_holder: 'NA', min_length_enabled: false, max_length_enabled: false },
        { name: "Premium", _id: "premium", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'NA', max_length_holder: 'NA', min_length_enabled: false, max_length_enabled: false  },
    ],

    ORB_SS_OPTIONS_BUY_TYPES: [
        { name: "Close Above", _id: "close_above", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Close Below", _id: "close_below", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Close Range", _id: "close_range", max_enabled: true, min_holder: 'Min Value', max_holder: 'Max Value', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "High Above", _id: "high_above", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "High Below", _id: "high_below", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "High Range", _id: "high_range", max_enabled: true, min_holder: 'Min Value', max_holder: 'Max Value', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
    ],

    ORB_SS_OPTIONS_SELL_TYPES: [
        { name: "Close Above", _id: "close_above", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Close Below", _id: "close_below", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Close Range", _id: "close_range", max_enabled: true, min_holder: 'Min Value', max_holder: 'Max Value', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Low Above", _id: "low_above", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Low Below", _id: "low_below", max_enabled: false, min_holder: 'Premium', max_holder: 'NA', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
        { name: "Low Range", _id: "low_range", max_enabled: true, min_holder: 'Min Value', max_holder: 'Max Value', inc: 'premium', min_length_holder: 'Min Len', max_length_holder: 'Max Len', min_length_enabled: true, max_length_enabled: true },
    ],

    ORB_SL_BUY_TYPES: [
        { name: "Standard", _id: "standard", default: true, min: 1, min_enabled: false, max_enabled: false },
        { name: "Candle Low", _id: "candle_low", default: false, min: 0, min_enabled: false, max_enabled: false },
        { name: "Candle Length", _id: "candle_length", default: false, min: 0, min_enabled: false, max_enabled: false },
        { name: "Min(Low)", _id: "min_low", default: false, min: 0, min_enabled: true, max_enabled: false },
        { name: "Max(Low)", _id: "max_low", default: false, min: 0, min_enabled: true, max_enabled: false },
        { name: "MinMax(Low)", _id: "min_max_low", default: false, min: 0, min_enabled: true, max_enabled: true },
    ],

    ORB_SL_SELL_TYPES: [
        { name: "Standard", _id: "standard", default: true, min: 1, min_enabled: false, max_enabled: false },
        { name: "Candle High", _id: "candle_high", default: false, min: 0, min_enabled: false, max_enabled: false },
        { name: "Candle Length", _id: "candle_length", default: false, min: 0, min_enabled: false, max_enabled: false },
        { name: "Min(High)", _id: "min_high", default: false, min: 0, min_enabled: true, max_enabled: false },
        { name: "Max(High)", _id: "max_high", default: false, min: 0, min_enabled: true, max_enabled: false },
        { name: "MinMax(High)", _id: "min_max_high", default: false, min: 0, min_enabled: true, max_enabled: true },
    ],

    ORB_TGT_BUY_TYPES: [
        { name: "Standard", _id: "standard", default: true },
        { name: "Candle Length", _id: "candle_length", default: false },
    ],

    ORB_TGT_SELL_TYPES: [
        { name: "Standard", _id: "standard", default: true },
        { name: "Candle Length", _id: "candle_length", default: false },
    ],

    VALUE_TYPES: [
        { name: "Points", _id: "pts", default: false },
        { name: "Percent", _id: "percent", default: true, default_value: 10 },
    ],

    SCRIPT_TYPES: [
        { name: "Internal", _id: "internal", default: true, },
        { name: "External", _id: "external", default: false },
    ]
}
